import AddressVehicleDetailsBubble from './AddressVehicleDetailsBubble';

export default AddressVehicleDetailsBubble;
